import { PropTypes } from 'prop-types';
import { Button, Pagination } from 'antd';
import { useIntl } from 'react-intl';
import styles from './index.module.scss';

const { paginationDropdown } = styles;

const AccionaTablePagination = ({
  pagination,
  setPagination,
  showSizeChanger,
}) => {
  const intl = useIntl();
  const itemRender = (page, type, originalElement) => {
    const isFirstPage = pagination.current === 1;
    const isLastPage =
      pagination.current === Math.ceil(pagination.total / pagination.pageSize);

    if (type === 'prev') {
      return (
        <Button
          type="link"
          disabled={isFirstPage}
          style={isFirstPage ? { color: '#ccc', cursor: 'not-allowed' } : {}}
        >
          {intl.formatMessage({ id: 'previous' })}
        </Button>
      );
    }

    if (type === 'next') {
      return (
        <Button
          type="link"
          disabled={isLastPage}
          style={isLastPage ? { color: '#ccc', cursor: 'not-allowed' } : {}}
        >
          {intl.formatMessage({ id: 'next' })}
        </Button>
      );
    }

    if (type === 'page') {
      return (
        <span style={page === pagination.current ? { color: 'white' } : {}}>
          {page}
        </span>
      );
    }

    return originalElement;
  };

  return (
    <Pagination
      current={pagination.current}
      pageSizeOptions={['5', '10', '20', '50', '100']}
      showSizeChanger={
        showSizeChanger
          ? {
              styles: {
                root: { width: 120 },
              },
              classNames: {
                popup: { root: paginationDropdown },
              },
            }
          : false
      }
      size="large"
      responsive
      pageSize={pagination.pageSize}
      total={pagination.total}
      itemRender={itemRender}
      onChange={(page, pageSize) => {
        return setPagination((prev) => ({
          ...prev,
          current: page,
          pageSize,
        }));
      }}
    />
  );
};

AccionaTablePagination.propTypes = {
  pagination: PropTypes.shape({
    total: PropTypes.number,
    pageSize: PropTypes.number,
    current: PropTypes.number,
  }).isRequired,
  setPagination: PropTypes.func.isRequired,
  showSizeChanger: PropTypes.bool.isRequired,
};

AccionaTablePagination.defaultProps = {};

export default AccionaTablePagination;
